import React from "react";
import { Col, Row, Image } from "react-bootstrap";

import classes from "./Introduction.module.css";

import stockimage from "../../assets/images/stock-image.png";

interface Props {
  introText: string | undefined | null;
}
const introduction: React.FunctionComponent<Props> = (props) => (
  <div data-test="introductionComponent">
    <Row>
      <Col sm={12} md={9}>
        <h2>Welcome</h2>
        <p>
          {props.introText?.split("\n").map((item, key) => {
            return (
              <span key={key}>
                {item}
                <br />
              </span>
            );
          })}
        </p>
      </Col>
      <Col sm={12} md={3} className={classes.introImg}>
        <Image
          src={stockimage}
          alt="stock-image"
          className={classes.stockimage}
          data-test="stockIMG"
        />
      </Col>
    </Row>
  </div>
);
export default introduction;
